var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('IdfSelect',{attrs:{"label":_vm.$t('ctx.discount.listing.discount-type-filter-label'),"placeholder":_vm.$t('ctx.discount.listing.discount-type-filter-placeholder'),"items":_vm.items},model:{value:(_vm.discountType),callback:function ($$v) {_vm.discountType=$$v},expression:"discountType"}})
}
var staticRenderFns = []

export { render, staticRenderFns }